<script setup>
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import { gql } from "@apollo/client/core";
import { useQuery, useResult } from "@vue/apollo-composable";
import { getMessageFromError } from "@/libs/errors";
import UserArea from "../../components/ui/UserArea.vue";
import { dateToUser, formatCurrency } from "@/libs/filters";
import { platform } from "@/libs/environment";
import { useCordovaStore } from "@/stores/cordova";
import { watch } from "vue";
import { useRouter } from "vue-router";

const cordovaStore = useCordovaStore();
const router = useRouter();
const {
  loading: subscriptionsLoading,
  error: subscriptionsError,
  result: subscriptionsResult,
} = useQuery(
  gql`
    query MySubscriptions {
      mySubscriptions {
        id
        description
        createdAt
        validFrom
        validUntil
        cycle
        nextDueDate
        billingType
        status
        active
        trial
        value
      }
    }
  `,
  {},
  {
    fetchPolicy: "no-cache",
  }
);
const subscriptions = useResult(
  subscriptionsResult,
  null,
  (data) => data.mySubscriptions
);

// Redirect to new-subscription if no subscriptions history after loading
watch(
  () => [subscriptionsLoading.value, subscriptions.value],
  ([loading, subs]) => {
    if (!loading && (!subs || !subs.length)) {
      router.replace("/user/new-subscription");
    }
  },
  { immediate: true }
);

// cordovaStore.refreshStore()
</script>

<template>
  <DefaultLayout>
    <article class="container framework-slot">
      <UserArea title="Histórico de Assinaturas">
        <div v-if="subscriptionsLoading" class="row">
          <div class="col-md-12 mb-3">CARREGANDO DADOS...</div>
        </div>
        <div v-else-if="subscriptionsError" class="row">
          <div class="col-md-12 mb-3">
            {{ getMessageFromError(subscriptionsError) }}
          </div>
        </div>
        <template v-else>
          <div
            v-if="
              !subscriptions ||
              !subscriptions.length ||
              !subscriptions[0].active
            "
            class="row"
          >
            <div class="col">
              <router-link
                class="btn btn-submit btn-primary mb-3"
                to="/user/new-subscription"
              >
                Ver planos de assinatura
              </router-link>
            </div>
          </div>
          <div
            v-if="
              platform !== 'web' &&
              subscriptions &&
              subscriptions.length &&
              subscriptions[0].active
            "
          >
            <button
              class="btn btn-submit btn-primary mb-3"
              @click="cordovaStore.manageSubscriptions()"
            >
              Gerenciar assinaturas
            </button>
          </div>
          <div class="row subscriptions">
            <div
              v-for="subscription of subscriptions"
              :key="subscription.id"
              class="col-12 col-lg-6"
            >
              <div class="subscription">
                <h3>{{ subscription.description }}</h3>
                <p v-if="subscription.active && subscription.value">
                  Próximo pagamento: {{ formatCurrency(subscription.value) }} em
                  {{ dateToUser(subscription.nextDueDate) }}
                </p>
                <p>
                  Validade:
                  {{ dateToUser(subscription.validFrom) }}
                  à
                  {{ dateToUser(subscription.validUntil) }}
                </p>
                <div v-if="subscription.active" class="mt-2">
                  <router-link
                    class="btn btn-danger btn-sm"
                    to="/user/cancel-subscription"
                  >
                    Cancelar Assinatura
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </template>
      </UserArea>
    </article>
  </DefaultLayout>
</template>

<style scoped>
.subscriptions .subscription {
  width: 100%;
  background: var(--black-eigengrau);
  padding: 1rem;
  border-radius: 0.25rem;
  margin-bottom: 1rem;
}

.subscriptions .subscription h3 {
  color: var(--primary-color);
  font-size: 1.2rem;
}

.subscriptions .subscription p {
  margin-bottom: 0;
}
</style>
